module.exports = __webpack_public_path__ + "img/image18.d5df116e.jpg";